module.exports = __webpack_public_path__ + "img/wave_ASTRORG.08a1265d.svg";